import { SvgColor } from "components/svg-color";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import GroupIcon from "@mui/icons-material/Group";
import DiscountIcon from "@mui/icons-material/Discount";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
  Apps,
  Attractions,
  Dashboard,
  Help,
  MessageOutlined,
  MilitaryTech,
} from "@mui/icons-material";
import PaymentsIcon from "@mui/icons-material/Payments";
import CategoryIcon from "@mui/icons-material/Category";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    width="100%"
    height="100%"
    src={`/assets/icons/navbar/${name}.svg`}
  />
);

export const navData = [
  {
    title: "داشبورد",
    path: "/",
    icon: icon("ic-analytics"),
  },
  {
    title: "مدیران سیستم",
    path: "/user",
    icon: icon("ic-user"),
  },
  {
    title: "نوتیفیکیشن",
    path: "/notification",
    icon: <MessageOutlined />,
  },
  {
    title: "مشتریان",
    path: "/customer",
    icon: <GroupIcon />,
  },
  {
    title: "سرویس‌ها",
    path: "/_services",
    icon: <Apps />,
    children: [
      {
        title: "دسته‌بندی‌ها",
        path: "/services/categories",
      },
      {
        title: "لیست سرویس‌ها",
        path: "/services",
      },
      {
        title: "یوزکیس‌ها",
        path: "/usecases",
      },
    ],
  },
  // {
  //   title: "یوزکیس‌ها",
  //   path: "/usecases",
  //   icon: <CategoryIcon />,
  // },
  // {
  //   title: "درخواست‌ها",
  //   path: "/request",
  //   icon: <ReceiptIcon />,
  // },
  {
    title: "مدیریت کد تخفیف",
    path: "/coupons",
    icon: <DiscountIcon />,
  },
  {
    title: "مدیریت پلن‌ها ",
    path: "/plans",
    icon: <CardMembershipIcon />,
  },
  {
    title: "مدیریت بازی‌ها",
    path: "/games",
    icon: <SportsEsportsIcon />,
  },
  // {
  //   title: "گزارش لینک‌ها",
  //   path: "/clicks",
  //   icon: <AssessmentIcon />,
  // },
  // {
  //   title: "پرداخت‌ها",
  //   path: "/_payments",
  //   icon: <PaymentsIcon />,
  //   children: [
  //     {
  //       title: "لیست پرداخت‌ها",
  //       path: "/payments",
  //     },
  //     // {
  //     //   title: "لیست درخواست‌های برداشت",
  //     //   path: "/payments/withdrawals",
  //     // },
  //   ],
  // },
  {
    title: "جایزه‌ها",
    path: "/prizes",
    icon: <EmojiEventsIcon />,
  },
  {
    title: "گردونه شانس",
    path: "/_wheel",
    icon: <Attractions />,
    children: [
      {
        title: "لیست گردونه‌ها",
        path: "/wheel",
      },
      {
        title: "لیست چرخش‌ها",
        path: "/wheel/spins",
      },
    ],
  },
  {
    title: "چیدمان صفحه خانه",
    path: "/layout",
    icon: <Dashboard />,
  },
  {
    title: "وب‌بنرها",
    path: "/sliders",
    icon: <PermMediaIcon />,
  },
  {
    title: "گزارشات",
    path: "/_reports",
    icon: <AssessmentIcon />,
    children: [
      {
        title: "گزارشات",
        path: "/reports",
      },

      {
        title: "لیست پرداخت‌ها",
        path: "/payments",
      },
      {
        title: "گزارش لینک‌ها",
        path: "/clicks",
      },
      {
        title: "درخواست‌ها",
        path: "/request",
      },
    ],
  },
  {
    title: "تبدیل امتیاز",
    path: "/_score",
    icon: <MilitaryTech />,
    children: [
      {
        title: "تنظیم تبدیل امتیازات",
        path: "/score",
      },
      {
        title: "لیست تبدیل امتیازات",
        path: "/score/conversions",
      },
    ],
  },
  {
    title: "سوالات متداول",
    path: "/faq",
    icon: <Help />,
  },
];
